import { render, staticRenderFns } from "./EstimatesDetails.vue?vue&type=template&id=33de9206&scoped=true&"
import script from "./EstimatesDetails.vue?vue&type=script&lang=js&"
export * from "./EstimatesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de9206",
  null
  
)

export default component.exports